<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="5" lg="4" xl="3">
      <v-card class="elevation-12" :loading="$async.authenticate.$pending">
        <v-toolbar elevation="1">
          <v-toolbar-title>
            <span class="title ml-3 mr-1">{{ $t('page-sign-in.title') }}</span>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <!-- <LanguagePopover/> -->
          <div style="min-height: 48px">
            <div class="red--text" v-if="invalidCredentials">
              <v-icon color="red">mdi-alert</v-icon>
              {{ $t('page-sign-in.wrongCredentials') }}
            </div>
          </div>
          <FormSignIn @submit="onSubmit" :loading="$async.authenticate.$pending" />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { loginFunc } from '@/services/auth'
import { defaultRedirect } from '@/router'
import FormSignIn from './form-sign-in'
// import LanguagePopover from '@/components/language-popover'
import authenticateMutation from '@/services/gql/mutations/authenticate.gql'

export default {
  name: 'PageSignIn',
  components: {
    FormSignIn
    // LanguagePopover
  },
  metaInfo () {
    const titleLocale = this.$t('page-titles.page-sign-in')
    return {
      title: titleLocale
    }
  },
  data () {
    return {
      invalidCredentials: false
    }
  },
  methods: {
    async onSubmit ({ login, password }) {
      this.invalidCredentials = false
      try {
        const {
          data: {
            authenticate: { accessToken, refreshToken }
          }
        } = await this.$async.authenticate.$perform({
          data: {
            login,
            password
          }
        })
        loginFunc({ accessToken, refreshToken })
        const redirectPath = this.$route.query.redirect
        const route = redirectPath ? { path: this.$route.query.redirect } : { name: defaultRedirect() }
        this.$router.push(route).catch((e) => {
          console.log(e)
        })
      } catch (e) {
        this.invalidCredentials = true
      }
    }
  },
  async: {
    authenticate (variables) {
      return this.$apollo.mutate({
        mutation: authenticateMutation,
        variables
      })
    }
  }
}
</script>
